import "./CalculatedPayrollAdjustmentDataGridStyle.css";

import { Box, CircularProgress, Typography, useTheme } from "@mui/material";
import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedDropDownRHF,
	RHookFormNumberField,
	RequestParams,
} from "@websential/cosmic-v20";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { formatDate, formatDateToShow, formatThousandSeperatorWithTwoFixedAmount } from "../../../common/Common";

import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { MultiSelect } from "primereact/multiselect";
import isEqual from "lodash/isEqual";

export interface ICalculatedPayrollAdjustmentDataGrid {
	rows: any;
	columns: any;
	showIndexColumn: boolean;
	showChecboxColumn: boolean;
	onRowDeleteClicked?: (params: any) => void;
	onRowEditClicked?: (params: any) => void;
	isLoading?: any;
	onSnackbarMessageData?: (value: any) => void;
	onRequestParamsChange?: (params: RequestParams) => void;
	initialPageSize?: number | undefined;
	initialPage?: number;
	totalRecords?: number;
	selectionToolbar?: (selectedItems: any) => React.ReactNode;
	selectedRowsValues?: any;
	changeLoginForGetEmptyItemsBySearchQuery?: any;
	searchFieldPlaceholder?: string;
	showGlobalSearch?: boolean;
	tableMargin?: string;
	rowsPerPageOptions?: number[];
	footer?: any;
	whiteSpace?: string;
	requestParamsToInitial?: boolean;
	tableScrollHeight?: boolean;
	pageTitle?: string;
	PayrollAdjustmentTableData: (data: any) => void;
}

export const CalculatedPayrollAdjustmentDataGrid: React.FC<ICalculatedPayrollAdjustmentDataGrid> = ({
	rows,
	columns,
	showIndexColumn,
	showChecboxColumn,
	onRowDeleteClicked,
	onRowEditClicked,
	isLoading,
	onSnackbarMessageData,
	onRequestParamsChange,
	initialPageSize = 10,
	initialPage = 0,
	totalRecords,
	selectionToolbar,
	selectedRowsValues,
	searchFieldPlaceholder,
	showGlobalSearch = true,
	tableMargin,
	rowsPerPageOptions,
	changeLoginForGetEmptyItemsBySearchQuery,
	footer,
	whiteSpace,
	requestParamsToInitial,
	tableScrollHeight,
	pageTitle,
	PayrollAdjustmentTableData,
}) => {
	const isInitialRequest = useRef(true);
	const [loading, setLoading] = useState(false);
	const [payrollItems, setPayrollItems] = useState<any>(
		rows && rows
	);

	useEffect(() => {
		PayrollAdjustmentTableData(payrollItems);

	}, [payrollItems]);

	useEffect(() => {
		if (!isEqual(rows, payrollItems)) {
			setPayrollItems([...rows]);
		}
	}, [rows]);

	const theme = useTheme();
	const [itemSearch, setItemSearch] = useState("");
	const [requestParams, setRequestParams] = useState<any>({
		first: initialPage,
		rows: initialPageSize,
		page: initialPage,
		sortField: null,
		sortOrder: "asc",
		searchQuery: "",
		filters: {
			name: { value: "", matchMode: "contains" },
			"country.name": { value: "", matchMode: "contains" },
			company: { value: "", matchMode: "contains" },
			"representative.name": { value: "", matchMode: "contains" },
		},
	});

	const [selectedItems, setSelectedItems] = useState<any>([]);
	const [selectedItemsIds, setSelectedItemsIds] = useState<any>([]);
	const [itemSearsch, setItemSearsch] = useState("");
	const onSearchButtonClicked = () => {
		setLoading(true);
		setRequestParams((prevParams: any) => ({
			...prevParams,
			first: initialPage,
			rows: initialPageSize,
			page: initialPage,
			searchQuery: itemSearch,
		}));
		if (changeLoginForGetEmptyItemsBySearchQuery) {
			changeLoginForGetEmptyItemsBySearchQuery(false);
		}
		setTimeout(() => {
			setLoading(false);
		}, 1000);
	};
	const handleClearSearch = () => {
		setLoading(true);
		setItemSearch("");
		setRequestParams((prevParams: any) => ({
			...prevParams,
			first: initialPage,
			rows: initialPageSize,
			page: initialPage,
			searchQuery: "",
		}));
		if (changeLoginForGetEmptyItemsBySearchQuery) {
			changeLoginForGetEmptyItemsBySearchQuery(false);
		}
		setTimeout(() => {
			setLoading(false);
		}, 1000);
	};

	const renderHeader = () => {
		return (
			<div
				style={{
					display: "flex",
					// justifyContent:showGlobalSearch ? "space-between" : "end",
					justifyContent: "space-between",
					alignItems: "center",
				}}
			>
				{showGlobalSearch && (
					<span
						className="p-input-icon-left w-3"
						style={{ display: "flex", marginLeft: "10px", height: "37px" }}
					>
						<i className="pi pi-search" />
						<InputText
							value={itemSearch}
							onChange={(e) => setItemSearch(e.target.value)}
							placeholder={
								searchFieldPlaceholder ? searchFieldPlaceholder : "Search..."
							}
							className="w-full"
							style={{ borderRadius: "2px 0px 0px 2px" }}
						/>
						{itemSearch && (
							<Button
								icon="pi pi-times"
								onClick={handleClearSearch}
								className="p-button-warning"
								style={{ borderRadius: 0 }}
							/>
						)}
						<Button
							onClick={onSearchButtonClicked}
							severity={EnhancedButtonPrimeReactSeverity.Secondary}
							style={{
								// padding:"8px 10px 8px 10px",
								padding: "10px 22px 10px 10px",
								// marginRight:"-14px!important",
								borderRadius: "0px 2px 2px 0px",
								// backgroundColor: theme.palette.primary.main
							}}
						>
							{/* <SearchIcon /> */}
							Search
						</Button>
					</span>
				)}
				{/* {selectionToolbar && selectionToolbar(selectedItemsIds)} */}
				{selectionToolbar && selectionToolbar(selectedItems)}
			</div>
		);
	};
	const headerSearch = renderHeader();

	const onPage = (event: any) => {
		// setRequestParams(event);
		setLoading(true);
		//imitate delay of a backend call
		setTimeout(() => {
			setRequestParams({
				...event,
				searchQuery: itemSearch,
			});
			setLoading(false);
		}, 1000);
	};
	const [sortField, setSortField] = useState(null);
	const [sortOrder, setSortOrder] = useState(1);
	const onSort = useCallback(
		(event: any) => {
			setLoading(true);

			let newSortOrder: any;
			if (event.sortField === sortField) {
				// Toggle sortOrder between 1 and -1
				newSortOrder = sortOrder === 1 ? -1 : 1;
				setSortOrder(newSortOrder);
			} else {
				// Set the new sortField and reset sortOrder to 1
				newSortOrder = 1;
				setSortField(event.sortField);
				setSortOrder(newSortOrder);
			}


			setRequestParams((prevParams: any) => ({
				...prevParams,
				sortOrder: newSortOrder !== 1 ? "asc" : "desc",
				sortField: event.sortField,
			}));

			// Imitate delay of a backend call
			setTimeout(() => {
				setLoading(false);
			}, 1000);
		},
		[sortOrder, sortField]
	);
	// This useEffect is triggered when the debouncedSearchQuery, pageSize or currentPage values change
	useEffect(() => {
		// if the results fetcher was passed, we can use it to fetch the results.
		if (onRequestParamsChange) {
			// skip the first initial call
			if (isInitialRequest.current === true) {

				isInitialRequest.current = false;
			} else {

				onRequestParamsChange(requestParams);
			}
		}
	}, [onRequestParamsChange, requestParams, requestParamsToInitial]);

	useEffect(() => {
		if (requestParamsToInitial && requestParams.first !== initialPage) {
			setRequestParams({
				first: initialPage,
				rows: initialPageSize,
				page: initialPage,
				sortField: null,
				sortOrder: "asc",
				searchQuery: "",
				filters: {
					name: { value: "", matchMode: "contains" },
					"country.name": { value: "", matchMode: "contains" },
					company: { value: "", matchMode: "contains" },
					"representative.name": { value: "", matchMode: "contains" },
				},
			});

		}

	}, [requestParamsToInitial, onRequestParamsChange, requestParams]);

	const onSelectionModelChange = useCallback(
		(items: any) => {
			let selectedItemsIds = items.value.map((item: any) => item.id);
			// setSelectedItems(selectedItemsIds);
			// Check for deleted items and remove them from selectedItems
			const updatedSelectedItems = items.value.filter((selectedItem: any) => {
				return rows && rows.find((row: any) => row.id === selectedItem.id);
			});
			setSelectedItems(updatedSelectedItems);
			setSelectedItemsIds(selectedItemsIds);
			if (selectedRowsValues) {
				if (items.value.length > 0) {
					const selectedRowData = rows.filter((row: any) => {
						return items.value.includes(row);
					});

					selectedRowsValues(selectedRowData);
				} else {
					selectedRowsValues(items.value);

				}
			}
		},
		[rows, selectedRowsValues, selectedItems]
	);
	// useEffect(() => {
	// 	// Check for deleted items and remove them from selectedItems
	// 	const updatedSelectedItems =
	// 		selectedItems &&
	// 		selectedItems.length > 0 &&
	// 		selectedItems.filter((selectedItem: any) => {
	// 			return rows && rows.find((row: any) => row.id === selectedItem.id);
	// 		});
	// 	// Only update if there are changes to selectedItems
	// 	if (
	// 		updatedSelectedItems &&
	// 		updatedSelectedItems.length !== selectedItems.length
	// 	) {
	// 		setSelectedItems(updatedSelectedItems);

	// 		// Update selectedItemsIds
	// 		const updatedSelectedItemsIds = updatedSelectedItems.map(
	// 			(item: any) => item.id
	// 		);
	// 		setSelectedItemsIds(updatedSelectedItemsIds);
	// 	}
	// }, [rows, selectedItems]);
	useEffect(() => {
		if (selectedItems && selectedItems.length > 0) {
			// Check if all selected items exist in rows
			const allExist = selectedItems.every((selectedItem: any) =>
				rows?.some((row: any) => row.employeeId === selectedItem.employeeId)
			);
			if (!allExist) {
				// ❌ One or more items removed → reset to initial state
				setSelectedItems([]);
				setSelectedItemsIds([]);
				if (selectedRowsValues) selectedRowsValues([]);
			}
		}
	}, [rows]);


	const onCellValueChange = (column: any, rowIndex: number, value: any) => {
		if (showChecboxColumn) {
			setPayrollItems((prev: any[]) => {
				const updatedData = [...prev];
				const updatedRow = { ...updatedData[rowIndex], [column.field]: value };
				updatedData[rowIndex] = updatedRow;

				// Fix: re-map selectedItems to updatedData references
				setSelectedItems((prevSelected: any[]) =>
					prevSelected
						.map(sel => updatedData.find(r => r.id === sel.id))
						.filter(Boolean)
				);

				return updatedData;
			});
		} else {
			setPayrollItems((prev: any[]) => {
				const updatedData = [...prev];
				const updatedRow = updatedData[rowIndex];

				// mutate only the needed field (keeps same object reference)
				updatedRow[column.field] = value;

				return updatedData;
			});
		}
	};

	const columnsBody = (rowData: any, row: any, x: any) => {

		// And if we are using column body only then we have to use this
		if (x.isEditable) {
			if (x.type === 'number') {
				return (
					<InputNumber
						value={rowData[x.field]}
						// onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
						onValueChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
						// placeholder="0.00"
						minFractionDigits={2}
						maxFractionDigits={2}
						// inputClassName={`${x.field === 'vacationPay' ? "vacationPayField" : ""}`}
						inputClassName={
							x.field === 'vacationPay' ? 'vacationPayField' :
								x.field === 'holidayHours' ? 'holidayHoursField' :
									x.field === 'holidayPay' ? 'holidayHoursField' :
										x.field === 'holidayPayAccured' ? 'holidayHoursField' :
											x.edr === 'earnings' ? 'earningsField' :
												x.edr === 'deductions' ? 'deductionsField' :
													x.edr === 'reimbursements' ? 'reimbursementsField' :
														''}
						inputStyle={{ textAlign: "right" }}
						// onFocus={() => setActiveRowIndex(row.rowIndex)}
						onFocus={() => setActiveRowIndex(rowData.employeeId)}
					/>
				)
			}
		} else if (x.field === 'checkReferanceNumber') {
			return (
				<InputText
					value={rowData[x.field]}
					onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.target.value)}
					onFocus={() => setActiveRowIndex(rowData.employeeId)}
				/>
			)
		} else if (x.field === 'checkDate') {
			return (
				<Calendar
					value={rowData[x.field]}
					style={{
						margin: "8px 0px 4px 0px",
						width: "auto",
					}}
					onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
					dateFormat="M dd, yy"
					placeholder={"dd/mm/yyyy"}
					showButtonBar
					onFocus={() => setActiveRowIndex(rowData.employeeId)}
				/>
			)
		}
		else {

			return (
				<Typography sx={{ fontSize: ".875rem" }} onClick={() => setActiveRowIndex(rowData.employeeId)}>
					{rowData[x.field]}
				</Typography>
				// <span onClick={() => setActiveRowIndex(rowData.employeeId)}>
				// 	{rowData[x.field]}
				// </span>
			)
		}
	};



	const containerRef = useRef<HTMLDivElement>(null);
	const [containerWidth, setContainerWidth] = useState(0);
	const [totalColumnWidth, setTotalColumnWidth] = useState(0);

	useEffect(() => {
		if (!containerRef.current) return;
		const observer = new ResizeObserver(([entry]) => {
			setContainerWidth(entry.contentRect.width);
		});
		observer.observe(containerRef.current);
		return () => observer.disconnect();
	}, []);
	useEffect(() => {
		// compute total defined width of all columns
		const totalColumnWidth = columns && columns.reduce(
			(sum: any, col: any) => sum + (col.maxWidth || 0),
			0
		);
		setTotalColumnWidth(totalColumnWidth)
	}, [columns]);




	// row highlighting (yellow background) when clicking any cell in that row
	const [activeRowIndex, setActiveRowIndex] = useState<number | null>(null);


	const getRowClassName = (data: any, options: any) => {

		return data.employeeId === activeRowIndex ? "highlighted-row" : "";
	};

	// // ─── STICKY HEADER USEEFFECT ───────────────────────────────────────────────
	// useEffect(() => {
	// 	const NAVBAR_HEIGHT = 112;
	// 	let stickyTable: HTMLElement | null = null;

	// 	const syncHorizontalScroll = () => {
	// 		if (!stickyTable || !containerRef.current) return;
	// 		const wrapper = containerRef.current.querySelector('.p-datatable-wrapper') as HTMLElement;
	// 		const cloneTable = stickyTable.querySelector('table') as HTMLElement;
	// 		if (!wrapper || !cloneTable) return;

	// 		const scrollLeft = wrapper.scrollLeft;
	// 		const cloneThs = cloneTable.querySelectorAll('th') as NodeListOf<HTMLElement>;
	// 		const originalThs = containerRef.current.querySelectorAll('.p-datatable-thead th') as NodeListOf<HTMLElement>;

	// 		cloneTable.style.transform = `translateX(-${scrollLeft}px)`;

	// 		cloneThs.forEach((cloneTh, i) => {
	// 			const originalTh = originalThs[i] as HTMLElement;
	// 			if (!originalTh) return;
	// 			if (originalTh.classList.contains('p-frozen-column')) {
	// 				cloneTh.style.transform = `translateX(${scrollLeft}px)`;
	// 			}
	// 		});
	// 	};

	// 	const createStickyHeader = () => {
	// 		if (!containerRef.current) return;
	// 		const originalTable = containerRef.current.querySelector('.p-datatable-table') as HTMLElement;
	// 		const originalThead = containerRef.current.querySelector('.p-datatable-thead') as HTMLElement;
	// 		const wrapper = containerRef.current.querySelector('.p-datatable-wrapper') as HTMLElement;
	// 		if (!originalTable || !originalThead || !wrapper) return;

	// 		document.querySelector('[data-sticky-table]')?.remove();

	// 		const containerRect = containerRef.current.getBoundingClientRect();

	// 		const fixedContainer = document.createElement('div');
	// 		fixedContainer.setAttribute('data-sticky-table', 'true');
	// 		fixedContainer.style.cssText = `
	// 			position: fixed;
	// 			top: ${NAVBAR_HEIGHT}px;
	// 			left: ${containerRect.left}px;
	// 			width: ${containerRect.width}px;
	// 			overflow: hidden;
	// 			z-index: 999;
	// 			background: #ffffff;
	// 			box-shadow: 0 2px 4px rgba(0,0,0,0.15);
	// 		`;

	// 		const cloneTable = originalTable.cloneNode(true) as HTMLElement;
	// 		cloneTable.style.cssText = `
	// 			table-layout: fixed;
	// 			width: ${originalTable.offsetWidth}px;
	// 			margin: 0;
	// 			border-collapse: collapse;
	// 			transform: translateX(-${wrapper.scrollLeft}px);
	// 		`;

	// 		cloneTable.querySelector('.p-datatable-tbody')?.remove();
	// 		cloneTable.querySelector('.p-datatable-tfoot')?.remove();

	// 		const originalThs = originalThead.querySelectorAll('th') as NodeListOf<HTMLElement>;
	// 		const cloneThs = cloneTable.querySelectorAll('th') as NodeListOf<HTMLElement>;

	// 		originalThs.forEach((th, i) => {
	// 			const cloneTh = cloneThs[i] as HTMLElement;
	// 			if (!cloneTh) return;

	// 			const width = th.getBoundingClientRect().width;
	// 			const computedStyle = window.getComputedStyle(th);
	// 			const computedBg = computedStyle.backgroundColor;

	// 			cloneTh.style.width = `${width}px`;
	// 			cloneTh.style.minWidth = `${width}px`;
	// 			cloneTh.style.maxWidth = `${width}px`;
	// 			cloneTh.style.backgroundColor = (computedBg && computedBg !== 'rgba(0, 0, 0, 0)') ? computedBg : '#ffffff';
	// 			cloneTh.style.color = computedStyle.color || '#0091b3';
	// 			cloneTh.style.fontWeight = 'bold';
	// 			cloneTh.style.fontSize = computedStyle.fontSize || '0.9rem';
	// 			cloneTh.style.fontFamily = computedStyle.fontFamily;
	// 			cloneTh.style.textAlign = 'left';
	// 			cloneTh.style.padding = '6px';
	// 			cloneTh.style.borderTop = '1px solid #e5e7eb';
	// 			cloneTh.style.borderBottom = '2px solid #e5e7eb';
	// 			cloneTh.style.borderRight = '1px solid #e5e7eb';
	// 			cloneTh.style.borderLeft = i === 0 ? '1px solid #e5e7eb' : '0';
	// 			cloneTh.style.whiteSpace = 'nowrap';
	// 			cloneTh.style.overflow = 'hidden';
	// 			cloneTh.style.textOverflow = 'ellipsis';
	// 			cloneTh.style.boxSizing = 'border-box';
	// 			cloneTh.style.verticalAlign = 'middle';

	// 			if (th.classList.contains('p-frozen-column')) {
	// 				cloneTh.style.position = 'sticky';
	// 				cloneTh.style.left = th.style.left || '0px';
	// 				cloneTh.style.zIndex = '10';
	// 				cloneTh.style.backgroundColor = (computedBg && computedBg !== 'rgba(0, 0, 0, 0)') ? computedBg : '#ffffff';
	// 			} else {
	// 				cloneTh.style.position = '';
	// 				cloneTh.style.left = '';
	// 				cloneTh.style.zIndex = '';
	// 			}

				
	// 			const headerContent = cloneTh.querySelector('.p-column-header-content') as HTMLElement;
	// 			if (headerContent) {
	// 				headerContent.style.display = 'flex';
	// 				headerContent.style.alignItems = 'center';
	// 				headerContent.style.color = computedStyle.color || '#0091b3';
	// 				headerContent.style.fontWeight = 'bold';
	// 			}

	// 			const titleSpan = cloneTh.querySelector('.p-column-title') as HTMLElement;
	// 			if (titleSpan) {
	// 				titleSpan.style.color = computedStyle.color || '#0091b3';
	// 				titleSpan.style.fontWeight = 'bold';
	// 				titleSpan.style.fontSize = computedStyle.fontSize || '0.9rem';
	// 				titleSpan.style.whiteSpace = 'nowrap';
	// 			}
	// 		});

	// 		// ── Selection column ──────────────────────────────────────────────
	// 		const cloneSelectionTh = cloneTable.querySelector('.selectionHeader') as HTMLElement;
	// 		if (cloneSelectionTh) {
	// 			cloneSelectionTh.style.width = '33px';
	// 			cloneSelectionTh.style.minWidth = '33px';
	// 			cloneSelectionTh.style.maxWidth = '33px';
	// 			cloneSelectionTh.style.textAlign = 'center';
	// 			cloneSelectionTh.style.padding = '0';
	// 			cloneSelectionTh.style.position = 'relative';

	// 			const headerContent = cloneSelectionTh.querySelector('.p-column-header-content') as HTMLElement;
	// 			if (headerContent) {
	// 				headerContent.style.display = 'flex';
	// 				headerContent.style.justifyContent = 'center';
	// 				headerContent.style.alignItems = 'center';
	// 				headerContent.style.width = '100%';
	// 				headerContent.style.height = '100%';
	// 				headerContent.style.padding = '0';
	// 			}

	// 			// Disable pointer events on clone checkbox
	// 			cloneSelectionTh.querySelectorAll('*').forEach((el: any) => {
	// 				el.style.pointerEvents = 'none';
	// 			});

	// 			// Transparent overlay forwards clicks to original
	// 			const overlay = document.createElement('div');
	// 			overlay.style.cssText = `
	// 				position: absolute;
	// 				top: 0; left: 0;
	// 				width: 100%; height: 100%;
	// 				cursor: pointer;
	// 				z-index: 20;
	// 				background: transparent;
	// 			`;

	// 			overlay.addEventListener('click', (e) => {
	// 				e.preventDefault();
	// 				e.stopPropagation();
	// 				// Fire on input
	// 				const originalInput = originalThead.querySelector(
	// 					'.selectionHeader input[type="checkbox"]'
	// 				) as HTMLInputElement;
	// 				if (originalInput) {
	// 					originalInput.dispatchEvent(new MouseEvent('mousedown', { bubbles: true, cancelable: true, view: window }));
	// 					originalInput.dispatchEvent(new MouseEvent('mouseup', { bubbles: true, cancelable: true, view: window }));
	// 					originalInput.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
	// 				}
	// 				// Fire on p-checkbox-box
	// 				const originalBox = originalThead.querySelector('.selectionHeader .p-checkbox-box') as HTMLElement;
	// 				if (originalBox) {
	// 					originalBox.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
	// 				}
	// 				// Fire on p-checkbox wrapper
	// 				const originalWrapper = originalThead.querySelector('.selectionHeader .p-checkbox') as HTMLElement;
	// 				if (originalWrapper) {
	// 					originalWrapper.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
	// 				}
	// 			});

	// 			cloneSelectionTh.appendChild(overlay);
	// 		}

	// 		fixedContainer.appendChild(cloneTable);
	// 		document.body.appendChild(fixedContainer);
	// 		stickyTable = fixedContainer;

	// 		// Hide original thead — opacity:0 so PrimeReact still updates DOM
	// 		originalThead.style.visibility = 'hidden';
	// 		originalThead.style.opacity = '0';
	// 		originalThead.style.pointerEvents = 'none';

	// 		// ── Checkbox visual sync ──────────────────────────────────────────
	// 		const cloneCheckboxWrapper = cloneTable.querySelector('.selectionHeader .p-checkbox') as HTMLElement;
	// 		const cloneCheckboxBox = cloneTable.querySelector('.selectionHeader .p-checkbox-box') as HTMLElement;

	// 		const syncCheckboxVisual = () => {
	// 			if (!containerRef.current || !cloneCheckboxWrapper || !cloneCheckboxBox) return;

	// 			// Count highlighted rows in tbody
	// 			const allRows = containerRef.current.querySelectorAll('.p-datatable-tbody .p-checkbox');
	// 			const highlightedRows = containerRef.current.querySelectorAll('.p-datatable-tbody .p-checkbox.p-highlight');
	// 			const total = allRows.length;
	// 			const checked = highlightedRows.length;

	// 			if (total === 0 || checked === 0) {
	// 				// Unchecked state
	// 				cloneCheckboxWrapper.classList.remove('p-highlight');
	// 				cloneCheckboxBox.classList.remove('p-highlight');
	// 				cloneCheckboxBox.style.backgroundColor = '';
	// 				cloneCheckboxBox.style.borderColor = '';
	// 				cloneCheckboxBox.innerHTML = '';
	// 			} else if (checked === total) {
	// 				// All checked state
	// 				cloneCheckboxWrapper.classList.add('p-highlight');
	// 				cloneCheckboxBox.classList.add('p-highlight');
	// 				cloneCheckboxBox.style.backgroundColor = '#6366f1';
	// 				cloneCheckboxBox.style.borderColor = '#6366f1';
	// 				cloneCheckboxBox.innerHTML = `
	// 					<svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" style="width:14px;height:14px;display:block;">
	// 						<path d="M11.6666 3.5L5.24992 9.91667L2.33325 7"
	// 							stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
	// 					</svg>
	// 				`;
	// 			} else {
	// 				// Indeterminate state
	// 				cloneCheckboxWrapper.classList.add('p-highlight');
	// 				cloneCheckboxBox.classList.add('p-highlight');
	// 				cloneCheckboxBox.style.backgroundColor = '#6366f1';
	// 				cloneCheckboxBox.style.borderColor = '#6366f1';
	// 				cloneCheckboxBox.innerHTML = `
	// 					<svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" style="width:14px;height:14px;display:block;">
	// 						<path d="M2.33325 7H11.6666"
	// 							stroke="white" stroke-width="2" stroke-linecap="round"/>
	// 					</svg>
	// 				`;
	// 			}
	// 		};

	// 		// Run immediately
	// 		syncCheckboxVisual();

	// 		// Poll every 80ms for reliable sync
	// 		const pollInterval = setInterval(syncCheckboxVisual, 80);
	// 		(stickyTable as any)._pollInterval = pollInterval;

	// 		// MutationObserver on tbody for immediate response
	// 		const tbody = containerRef.current?.querySelector('.p-datatable-tbody') as HTMLElement;
	// 		const observer = new MutationObserver(() => {
	// 			requestAnimationFrame(syncCheckboxVisual);
	// 		});
	// 		if (tbody) {
	// 			observer.observe(tbody, {
	// 				attributes: true,
	// 				attributeFilter: ['class'],
	// 				subtree: true,
	// 			});
	// 		}
	// 		(stickyTable as any)._checkboxObserver = observer;

	// 		wrapper.addEventListener('scroll', syncHorizontalScroll, { passive: true });
	// 	};

	// 	const removeSticky = () => {
	// 		const existing = document.querySelector('[data-sticky-table]') as any;
	// 		if (existing?._checkboxObserver) existing._checkboxObserver.disconnect();
	// 		if (existing?._pollInterval) clearInterval(existing._pollInterval);
	// 		document.querySelector('[data-sticky-table]')?.remove();
	// 		stickyTable = null;
	// 		if (!containerRef.current) return;
	// 		const originalThead = containerRef.current.querySelector('.p-datatable-thead') as HTMLElement;
	// 		if (originalThead) {
	// 			originalThead.style.visibility = 'visible';
	// 			originalThead.style.opacity = '1';
	// 			originalThead.style.pointerEvents = '';
	// 		}
	// 		const wrapper = containerRef.current.querySelector('.p-datatable-wrapper') as HTMLElement;
	// 		wrapper?.removeEventListener('scroll', syncHorizontalScroll);
	// 	};

	// 	const handleScroll = () => {
	// 		if (!containerRef.current) return;
	// 		const originalThead = containerRef.current.querySelector('.p-datatable-thead') as HTMLElement;
	// 		if (!originalThead) return;

	// 		const tableRect = containerRef.current.getBoundingClientRect();
	// 		const theadHeight = originalThead.getBoundingClientRect().height;

	// 		if (tableRect.top <= NAVBAR_HEIGHT && tableRect.bottom > NAVBAR_HEIGHT + theadHeight) {
	// 			if (!stickyTable) {
	// 				createStickyHeader();
	// 			} else {
	// 				const containerRect = containerRef.current.getBoundingClientRect();
	// 				stickyTable.style.left = `${containerRect.left}px`;
	// 				stickyTable.style.width = `${containerRect.width}px`;
	// 				syncHorizontalScroll();
	// 			}
	// 		} else {
	// 			if (stickyTable) removeSticky();
	// 		}
	// 	};

	// 	const handleResize = () => { if (stickyTable) removeSticky(); };

	// 	window.addEventListener('scroll', handleScroll, { passive: true });
	// 	window.addEventListener('resize', handleResize);

	// 	return () => {
	// 		window.removeEventListener('scroll', handleScroll);
	// 		window.removeEventListener('resize', handleResize);
	// 		removeSticky();
	// 	};
	// }, [columns, payrollItems]);


	return (
		<div
			ref={containerRef}
			style={{
				width: "100%",
				overflow: "hidden", // container stays fixed
				background: "#fff"
			}}
		>
			<DataTable
				value={rows && columns && payrollItems}
				responsiveLayout="scroll"
				// editMode={managedBy !== 100 ? "cell" : undefined} //non-editable for managed by simplepay
				showGridlines
				resizableColumns
				columnResizeMode="expand"
				scrollable
				scrollHeight={tableScrollHeight ? "75vh" : ""}
				// reorderableColumns
				loading={isLoading ? isLoading : loading}
				footer={footer ? footer : undefined}
				emptyMessage="No Record found."
				className="CalculatedPayrollAdjustmentDataGrid"
				style={{
					margin: `${tableMargin ? tableMargin : "14px 0.5rem 0.5rem 0"}`,
				}}
				selection={selectedItems}
				onSelectionChange={onSelectionModelChange}
				// selectionMode="multiple"
				selectionMode="checkbox"
				sortMode="single"
				/** 👇 Force fixed table layout so width styles are respected */
				// tableStyle={{ tableLayout: 'fixed', width: '100%' }}
				// tableStyle={{
				// 	tableLayout: 'fixed',
				// 	width: totalColumnWidth < containerWidth ? `${totalColumnWidth}px` : '100%',
				// }}
				tableStyle={{
					tableLayout: totalColumnWidth < containerWidth ? "fixed" : "auto",
					width: totalColumnWidth < containerWidth ? `${totalColumnWidth}px` : "100%"
				}}
				// onCellClick={(e) => alert("clicked")}
				rowClassName={getRowClassName}
			>
				{columns && rows && (
					<Column
						selectionMode="multiple"
						hidden={!showChecboxColumn}
						frozen
						resizeable={false}
						style={{ width: "36px", textAlign: "center" }}
						field="selection"
						columnKey="selection"
						className="selectionHeader"
						headerClassName="selectionHeader"
					></Column>
				)}
				{columns &&
					columns
						.sort((a: any, b: any) => (a.sequence ?? 0) - (b.sequence ?? 0))
						.map((x: any, index: any) => {
							return (
								<Column
									key={index}
									field={x.field}
									header={x.headerName}
									headerTooltip={x.description}
									headerTooltipOptions={{ position: "top" }}
									hidden={x.hide}
									// sortable={x.sortable}
									reorderable={false}
									dataType={x.type}
									align={x.align}
									alignHeader={x.headerAlign}
									exportable={x.disableExport}
									frozen={totalColumnWidth < containerWidth ? false : x.frozenColumn}
									alignFrozen={x.alignFrozen}
									columnKey={x.field}
									style={{
										minWidth: x.minWidth,
										fontSize: "0.875rem",
										width: x.maxWidth,
										maxWidth: x.maxWidth,
										// width: x.maxWidth,
									}}

									headerStyle={{
										whiteSpace: whiteSpace ? whiteSpace : "nowrap",
									}}
									headerClassName={
										x.field === 'vacationPay' ? 'vacationPayField' :
											x.field === 'vacationPayAccured' ? 'vacationPayField' :
												x.field === 'holidayHours' ? 'holidayHoursField' :
													x.field === 'holidayPayAccured' ? 'holidayHoursField' :
														x.field === 'holidayPay' ? 'holidayHoursField' :
															x.edr === 'earnings' ? 'earningsField' :
																x.edr === 'deductions' ? 'deductionsField' :
																	x.edr === 'reimbursements' ? 'reimbursementsField' :
																		''}
									className={
										x.field === 'vacationPay' ? 'vacationPayField' :
											x.field === 'vacationPayAccured' ? 'vacationPayField' :
												x.field === 'holidayHours' ? 'holidayHoursField' :
													x.field === 'holidayPayAccured' ? 'holidayHoursField' :
														x.field === 'holidayPay' ? 'holidayHoursField' :
															x.edr === 'earnings' ? 'earningsField' :
																x.edr === 'deductions' ? 'deductionsField' :
																	x.edr === 'reimbursements' ? 'reimbursementsField' :
																		''}
									footer={x.footer}
									body={(rowData: any, row: any) =>
										columnsBody(rowData, row, x)
									}
								/>
							);
						})}
			</DataTable>
		</div>
	);
};
